<template>
    <div
        class="absolute -bottom-6 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:bottom-auto md:-right-6 md:top-[56px] h-12 w-12 p-2.5 bg-white rotate-90 md:rotate-0 rounded-full shadow-[0px_0px_0px_2px_rgba(255,255,255,1.00)] border border-slate-200 justify-center items-center inline-flex overflow-hidden z-30"
    >
        <div class="w-5 h-5 justify-center items-center flex overflow-hidden">
            <div
                class="w-5 h-5 relative flex-col justify-start items-start flex overflow-hidden"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 text-slate-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>
